import React from 'react';

const BridgeIcon = (props) => {
  return (
    <img
      alt="Most"
      src="/static/images/icons/tourist_attractions/bridge.svg"
      {...props}
    />
  );
};

export default BridgeIcon;
